import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Calendar, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

export const BlogPage = () => {
  const blogPosts = [
    {
      id: 1,
      title: "A importância da manutenção preventiva em equipamentos de diagnóstico por imagem",
      excerpt: "Descubra como a manutenção preventiva pode prolongar a vida útil dos seus equipamentos e garantir diagnósticos precisos.",
      date: "2024-12-15",
      image: "https://images.unsplash.com/photo-1581595220892-b0739db3ba8c?w=800&q=80",
      category: "Manutenção"
    },
    {
      id: 2,
      title: "Tendências em tecnologia de imagem médica para 2025",
      excerpt: "Conheça as principais inovações tecnológicas que estão transformando o setor de diagnóstico por imagem.",
      date: "2024-12-10",
      image: "https://images.unsplash.com/photo-1559000357-f6b52ddfbe37?w=800&q=80",
      category: "Tecnologia"
    },
    {
      id: 3,
      title: "Vantagens da locação de equipamentos médicos",
      excerpt: "Entenda por que cada vez mais instituições de saúde estão optando pela locação ao invés da compra de equipamentos.",
      date: "2024-12-05",
      image: "https://images.unsplash.com/photo-1631556760585-2e846196d5a9?w=800&q=80",
      category: "Locação"
    },
    {
      id: 4,
      title: "Como escolher o equipamento de ultrassom ideal para sua clínica",
      excerpt: "Guia completo com os principais fatores a considerar na hora de adquirir um sistema de ultrassonografia.",
      date: "2024-11-28",
      image: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=800&q=80",
      category: "Equipamentos"
    },
    {
      id: 5,
      title: "PACS e Workstations: Otimizando o fluxo de trabalho em radiologia",
      excerpt: "Saiba como sistemas PACS e estações de trabalho especializadas podem melhorar a eficiência do seu centro de diagnóstico.",
      date: "2024-11-20",
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80",
      category: "Tecnologia"
    },
    {
      id: 6,
      title: "Qualidade de imagem em mamografia digital: O que você precisa saber",
      excerpt: "Fatores críticos que influenciam a qualidade das imagens mamográficas e como garantir diagnósticos precisos.",
      date: "2024-11-15",
      image: "https://images.pexels.com/photos/13176357/pexels-photo-13176357.jpeg?w=800&q=80",
      category: "Equipamentos"
    }
  ];

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('pt-BR', options);
  };

  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 via-white to-cyan-50 py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-6">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900">
              Blog
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Artigos, novidades e informações sobre equipamentos de diagnóstico por imagem
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-16 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <Card key={post.id} className="hover:shadow-lg transition-shadow duration-300 overflow-hidden">
                <div className="h-48 overflow-hidden bg-gray-100">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <CardContent className="p-6 space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-blue-600 bg-blue-100 px-3 py-1 rounded-full">
                      {post.category}
                    </span>
                    <div className="flex items-center text-gray-500 text-sm">
                      <Calendar size={14} className="mr-1" />
                      {formatDate(post.date)}
                    </div>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 text-sm line-clamp-3">
                    {post.excerpt}
                  </p>
                  <Button variant="link" className="text-blue-600 p-0 h-auto">
                    Ler mais <ArrowRight size={16} className="ml-1" />
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <div className="space-y-6">
            <h2 className="text-3xl sm:text-4xl font-bold text-white">
              Precisa de mais informações?
            </h2>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto">
              Entre em contato com nossa equipe de especialistas
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-6 text-lg">
                Fale Conosco
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
